import $ from 'jquery' /*引入jquery*/
import secretESA from '../common/secretESA.js';
/*定位模块, 立即执行函数, eg: import '../modules/location.js'
 *定位逻辑: 判断cookie中的cancelbut_city是否为true(用户不想切换城市,直接返回),
 *          判断当前执行环境是否支持geolocation,不支持直接返回
 *          执行getCurrentPosition方法得到经纬度,调用主站的城市定位接口,传入经纬度返回城市参数
 *          与页面的城市参数作比对,一致直接返回,不一致则弹窗提示是否切换,
 *          用户点击确认切换更新cookie中mycity参数并且跳转到当前城市大类页
 *          用户点击取消,cookie中的cancelbut_city赋值true,一天失效
 *              mycity参数更新成当前页面城市(防止用户修改url中城市参数的方式进入大类页)
 */
export default function(params = {}){
    setTrackLog(params)
    unloadEvent()
    /*判断是否为true, 用户是否不想切换*/
    if(getCookie('cancelbut_city')) {
        // console.log('cancelbut_city')
        clickLog('lbs_data_cancelbut')
        return
    }
    /*当前执行环境是否支持定位方法*/
    if(!('geolocation' in navigator)) {
        console.log('ip')
        // alert('no support geolocation')
        /*调用后端ip定位接口方法*/
        ipLocation()
        clickLog('lbs_data_nonsupport')
        return
    }

    //防止重复提示获取定位权限问题
    if (getCookie('tiedot1')) {
        console.log('cookie')
        // var lat = getCookie('lat'),
        //     lon = getCookie('lon')
        var lat = secretESA['decrypt'](getCookie('tiedot2') || '');
        var lon = secretESA['decrypt'](getCookie('tiedot1') || '');
        handlePositionSuccess(lat, lon)
        clickLog('lbs_data_cookie')
    } else {
        console.log('location')
        clickLog('lbs_data_send')
        locationStatus = 0;
        navigator.geolocation.getCurrentPosition(
            /*定位成功回调函数*/
            function(position){
                // alert('geolocation success')
                var latitude  = position.coords.latitude ? (position.coords.latitude + '') : '',/*获取纬度*/
                    longitude = position.coords.longitude ? (position.coords.longitude + '') : '';/*获取经度*/
                // setCookie('lon', longitude, 0, 1, 0, 0)
                // setCookie('lat', latitude, 0, 1, 0, 0)
                setCookie('tiedot2', secretESA['encrypt'](latitude), 0.02);
                setCookie('tiedot1', secretESA['encrypt'](longitude), 0.02);
                handlePositionSuccess(latitude, longitude)
                clickLog('lbs_data_success')
                locationStatus = 1;
            }, 
            /*定位失败回调函数*/
            function(error){
                // alert(`geolocation error ${JSON.stringify(error)} ${typeof error.code}: ${error.code}, ${typeof error.PERMISSION_DENIED}: ${error.PERMISSION_DENIED}`)
                /*调用后端ip定位接口方法*/
                ipLocation()
                clickLog(`lbs_data_error_${error.code}`)
                locationStatus = 2;
                console.log('location_error',error)
                
                // if (error.code !== error.PERMISSION_DENIED) {
                //     // alert('geolocation error 不是没有权限，调用ipLocation')
                // }
            },
            {
                timeout: 2e3,
                maximumAge: 6e4,
                enableHighAccuracy: true
            }
        )
    }
}

function handlePositionSuccess(latitude, longitude) {
    var service_url = '//m.58.com/location/?l=' + latitude + '&d=' + longitude + '&callback=?',/*拼接主站获取城市参数的请求url*/
        activeCityName = ____json4fe.locallist[0].listname/*获取当前页面城市参数*/
    $.ajax({
        url: service_url,
        dataType: 'jsonp',
        success: function(data) {
            if(typeof data != 'object' || data.listname.length === 0) return
                /*调用城市参数比对方法*/
            judgeCity(data.listname, data.cityname)
        },
            /*ajax失败回调函数*/  
        error: function () {
                /*调用后端ip定位接口方法*/
                // alert('geolocation m.58.com error')
            ipLocation()
        }
    })
}

/**
 * 弹窗方法,直接将弹窗dom添加到body上
 * 
 * @param  {String} promptStr
 * 提示语句,显示在弹窗上的句子
 * 
 * @param  {Function} sureFun  
 * 点击确认按钮执行的方法
 * 
 * @param  {Function} cancelFun
 * 点击取消按钮执行的方法
 * 
 * @return {Undefined}
 */
function popupBox(promptStr, sureFun, cancelFun) {
    var popupBox = `<div class="locationBgLayer">
        <div class="popupBox">
            <button class="closeBtn">+</button>
            <h1>提示</h1>
            <p>${promptStr}</p>
            <button class="sureBtn">确认切换</button>
            <button class="cancelBtn">取消</button>
        </div>
    </div>`

    $('body').append(popupBox)

    $('.locationBgLayer').on('touchmove', function(event){
        event.preventDefault()
    })

    $('.popupBox').on('click', '.sureBtn', function(){
        $('.locationBgLayer').hide()
        typeof sureFun === 'function' && sureFun()
    })

    $('.popupBox').on('click', '.closeBtn, .cancelBtn', function(){
        $('.locationBgLayer').hide()
        typeof cancelFun === 'function' && cancelFun()
    })
}

function supernatant(promptStr) {
    $('body').append('<div id="supernatant">'+ promptStr +'</div>')
    setTimeout(function() {
        $('#supernatant').hide()
    }, 3000)
}

/**
 * 根据cookie名称获取值
 * 
 * @param  {String} name 希望获得cookie名字
 * 
 * @return {String}      对应的cookie值
 */
function getCookie(name) {
    var arr,
        reg=new RegExp('(^| )'+name+'=([^;]*)(;|$)')
    if(arr = document.cookie.match(reg)) {
        return decodeURIComponent(arr[2])
    }else {
        return null
    }
}

/**
 * 添加或修改cookie
 * 
 * @param {String} name  cookie名字
 * @param {String} value cookie值
 * @param {Number} day   cookie时效(可省略,默认30天)
 */
function setCookie(name, value, day = 30, hour = 0, minute = 0, second = 0) {
    // var Days = day || 30
    // alert(`${day},${hour},${minute},${second}`)
    var exp = new Date()
    exp.setTime(exp.getTime() + day*24*60*60*1000 + hour*60*60*1000 + minute*60*1000 + second*1000)
    document.cookie = name + '='+  (value) + ';expires=' + exp.toGMTString() + ';domain=.58.com;path=/'
}

function getUrlParameter (paraName) {
    var reg = new RegExp(paraName + '='),
        matchValue = ''
    if(location.search) {
        matchValue = location.search.slice(1).split('&').filter(function(item, index){
            return reg.test(item)
        })[0]
    }
    if(matchValue) {
        matchValue = matchValue.replace(reg, '')
    }
    return matchValue
}

/**
 * 根据名称修改url查询字符串中的值
 * @param {String} url       想要修改的url
 * @param {String} itemName  对应的名称
 * @param {String} itemValue 对应的值
 */
function setUrlItemValue(url, itemName, itemValue) {
    return url.split('?')[0] + '?' + url.split('?')[1].split('&').map(function(item){
        return item.indexOf(itemName + '=') === -1 ? item : itemName + '=' + itemValue
    }).join('&')
}

function judgeCity(citySpell, cityName) {
    var activeCityName = ____json4fe.locallist[0].listname/*获取当前页面城市参数*/
    /*比较当前页面城市参数与经纬度定位城市参数是否一致,不一致则弹窗*/
    if(citySpell === activeCityName) return
    /*弹窗方法*/
    popupBox(
        '当前定位城市为'+ cityName +'，是否切换？',
        /*点击确认的方法*/ 
        function(){
            if (getUrlParameter('city')) {
                // location.href = setUrlItemValue(location.href, 'city', citySpell)
                location.replace(setUrlItemValue(location.href, 'city', citySpell))
            } else {
                var reg = new RegExp(`/${activeCityName}/`)
                // location.href = location.href.replace(reg, `/${citySpell}/`)
                location.replace(location.href.replace(reg, `/${citySpell}/`))
            }
            setCookie('mcity', citySpell)
        },
        /*点击取消的方法*/
        function(){
            setCookie('cancelbut_city', true, 1)
            // setCookie('mcity', activeCityName);
        }
    )
}

function ipLocation() {
    $.ajax({
        url: '/api/getcity',
        type: 'post',
        success: function(response) {
            if (!response || !response.listname || !response.localname) {
                supernatant('获取位置信息失败，请确认定位权限')
                return
            }
            /*调用城市参数比对方法*/
            judgeCity(response.listname, response.localname)
        },
        error: function() {
            supernatant('获取位置信息失败，请确认定位权限')
        }
    })
}

var _trackLog = '';
var locationStatus = -1;// 浏览器定位状态
function setTrackLog(params = {}){
    var catentry = window.____json4fe.catentry,
        dispid = (!!catentry && catentry.length > 0) ? catentry[catentry.length - 1].dispid : '',/*页面的最底层类别*/
        templateNum = params.templateNum || getUrlParameter('-15'),
        line = params.line || '',
        AB_class =params.AB_class || '';
    dispid = params.dispid || dispid;
    _trackLog = [dispid,templateNum,line,AB_class].filter(item => !!item).join('_'); /*统计代码拼接串*/
}
function clickLog(log){
    if(typeof window.clickLog === 'function'){
        window.clickLog(`from=${log}_${_trackLog}_${new Date().getTime()}`);
    }else{
        let _int = setInterval(function(){
            if(typeof window.clickLog === 'function'){
                clearInterval(_int);
               window.clickLog(`from=${log}_${_trackLog}_${new Date().getTime()}`);
            }
        });
    }
}
function unloadEvent(){
    window.addEventListener('beforeunload',function(){
        if(locationStatus === 0){
            clickLog('lbs_data_unload')
        }
        
    })
}